import { render } from "./Role.vue?vue&type=template&id=017a50dc"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
script.render = render

export default script